// 达人视频轮播。
// 播放:每条视频滑进可视区域才把 data-src 填进 src 并播放,离开就暂停;没进过可视区域的视频一个字节都不下载。
//       IntersectionObserver 会算上轮播容器的裁切,横向滑到屏幕外的卡不算"可见"。
//       prefers-reduced-motion 时不播放,只显示封面(封面是普通懒加载图片)。
// 按钮:一次滚动一屏;滚到两端时对应按钮标为 aria-disabled(不用 disabled,否则键盘焦点会丢);
//       按钮是 <button>,键盘 Enter / 空格可用,轮播本身可聚焦后用方向键滚动。
(function () {
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideos(root) {
    var videos = root.querySelectorAll('.wb-creators__media');
    if (!videos.length || REDUCE || !window.IntersectionObserver) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (video.getAttribute('src')) {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    videos.forEach(function (video) {
      // 有画面了再盖住封面,避免加载中闪黑
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      io.observe(video);
    });
  }

  function initCarousel(section) {
    var track = section.querySelector('.wb-creators__track');
    var buttons = section.querySelectorAll('.wb-creators__btn');
    if (!track || !buttons.length) return;
    var raf = 0;

    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      buttons.forEach(function (button) {
        var dir = Number(button.dataset.dir);
        var atEnd = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
        button.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-disabled') === 'true') return;
        track.scrollBy({ left: Number(button.dataset.dir) * track.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    root.querySelectorAll('[data-wb-carousel]').forEach(function (section) {
      if (section.__wbCarousel) return;
      section.__wbCarousel = true;
      initCarousel(section);
      initVideos(section);
    });
  }

  init(document);
  // 主题编辑器里重新渲染版块
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
